import { useMemo } from "react";
import { useSelector } from "react-redux";
import { makeGetFilePermissionSelector } from "~/store/selectors/selector.files";

export const useFilePermission = (fileId) => {
  const getFilePermission = useMemo(() => makeGetFilePermissionSelector(fileId), [fileId]);

  return useSelector(getFilePermission);
};
